export default{
    //get data from local storage
    getLoggedIn : function() {
        localStorage.getItem('isLoggedin')
    },
    getUserId : function() {
        return localStorage.getItem('user_id')
    },
    getUserProfileId : function() {
        return localStorage.getItem('profileId')
    },
    getUserAliasName : function() {
        return localStorage.getItem('loginuseraliasname')
    },
    getUserEmail : function() {
        return localStorage.getItem('email')
    },
    getSelectedElement : function() {
        return localStorage.getItem('selectElement')
    },
    getProfileViewsActiveTab : function() {
        return localStorage.getItem('profileviewsElement')
    },
    getPeopleActiveTab : function() {
        return localStorage.getItem('activeElement1')
    },
    getSelectedSearchTab : function() {
        return localStorage.getItem('selectedSearchTab')
    },

    //set data to local storage
    setLoggedIn : function(value) {
        localStorage.setItem('isLoggedin', value)
    },
    setUserId : function(value) {
        localStorage.setItem('user_id', value)
    },
    setUserProfileId : function(value) {
        localStorage.setItem('profileId', value)
    },
    setUserAliasName : function(value) {
        localStorage.setItem('loginuseraliasname', value)
    },
    setUserEmail : function(value) {
        localStorage.setItem('email', value)
    },
    setSelectedElement : function(value) {
        console.log("value : ", value)
        localStorage.setItem('selectElement', value)
    },
    setProfileViewsActiveTab : function(value) {
        localStorage.setItem('profileviewsElement', value)
    },
    setPeopleActiveTab : function(value) {
        localStorage.setItem('activeElement1', value)
    },
    setSelectedSearchTab : function(value) {
        localStorage.setItem('selectedSearchTab', value)
    },

    // setSelectedJobId : function(value) {
    //     localStorage.setItem('selectedJobId', value)
    // },
    // setApplyStatus : function(value) {
    //     localStorage.setItem('selectedJobApplyStatus', value)
    // },
    // setActiveElement : function(value) {
    //     localStorage.setItem('activeElement', value)
    // },
    
    // setBusinessAccountId : function(value) {
    //     localStorage.setItem('business_account_id', value)
    // },
    // setCompanyProfileId : function(value) {
    //     localStorage.setItem('company_profile_id', value)
    // },

    
    // getSelectedJobId : function() {
    //     return localStorage.getItem('selectedJobId')
    // },
    // getApplyStatus : function() {
    //     return localStorage.getItem('selectedJobApplyStatus')
    // },
    // getActiveElement : function() {
    //     return localStorage.getItem('activeElement')
    // },
    
    // getBusinessAccountId : function() {
    //     return localStorage.getItem('business_account_id')
    // },
    // getCompanyProfileId : function() {
    //     return localStorage.getItem('company_profile_id')
    // },
}